<template>
    <Transition>
        <div
            v-if="showBasketPopover"
            id="basketPopover"
            ref="basketPopover"
            class="bg-white border border-brand rounded position-absolute shadow"
        >
            <div class="arrow-up position-absolute"></div>
            <div>
                <div class="bg-brand text-white text-start p-2 py-2">
                    <b>Your basket</b>
                </div>
                <div v-if="basket?.products?.length > 0" class="p-3">
                    <template v-if="basketTyres?.length > 0">
                        <p class="mb-0 small text-start">Your selected tyres</p>
                        <div v-for="(product, index) in basketTyres" :key="product.st_code">
                            <div class="d-flex justify-content-between">
                                <b>{{ product.brand }}</b>
                                <b>£{{ product.display_total }}</b>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column text-start">
                                    <p class="mb-0">{{ product.tyre_range }}</p>
                                    <small class="fw-light">{{ product.description }}</small>
                                </div>
                                <div>
                                    <p class="mb-0">Qty: {{ product.quantity }}</p>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </template>
                    <template v-if="basketServices?.length > 0">
                        <p class="mb-0 small text-start">Your selected extras</p>
                        <div v-for="(product, index) in basketServices" :key="product.st_code">
                            <div class="d-flex justify-content-between">
                                <b class="pe-2">{{ product.service_name }}</b>
                                <template v-if="product.price_type === 'fixed' || product?.product_type == 'cover'"><b>£{{ product.retail }}</b></template>
                                <template v-else>
                                    <b>£{{ parseFloat(product.retail * (basket.total_tyres != 0 ? basket.total_tyres : 1)).toFixed(2) }}</b>
                                </template>
                            </div>
                        </div>
                        <hr>
                    </template>
                    <template v-if="basketUpsells?.length > 0">
                        <p class="mb-0 small text-start">Your selected battery</p>
                        <div v-for="(battery, index) in basketUpsells" :key="battery.st_code">
                            <div class="d-flex justify-content-between">
                                <b class="pe-2">{{ battery?.meta.name }}</b>
                                <b>£{{ battery?.meta?.retail }}</b>
                            </div>
                        </div>
                        <hr>
                    </template>
                    <div class="text-start" v-if="basket.home_delivery == 0 && basket?.fitter_id">
                        <p class="d-block mb-0 small">Your selected fitter</p>
                        <div v-if="basket?.fitter?.name">
                            <b>{{ basket.fitter.name }}</b>
                        </div>
                        <div v-if="basket?.app_date">
                            <p class="mb-0">on {{ formattedDate }}</p>
                        </div>
                        <hr>
                    </div>
                    <div v-if="basket.mobile_fitting > 0" class="d-flex justify-content-between align-items-center">
                        <b>Mobile Fitting amount:</b>
                        <b>£{{ basket.mobile_fitting }}</b>
                    </div>
                    <hr v-if="basket.mobile_fitting > 0">
                    <div v-if="basket.delivery_amount > 0" class="d-flex justify-content-between align-items-center">
                        <b>Delivery amount:</b>
                        <b>£{{ basket.delivery_amount }}</b>
                    </div>
                    <hr v-if="basket.delivery_amount > 0">
                    <div class="d-flex justify-content-between align-items-center">
                        <b>Total</b>
                        <b>£{{ basket.total }}</b>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                        <a href="/basket" class="p-1 text-center btn btn-primary w-100 rounded small px-4 text-decoration-none">View basket</a>
                    </div>
                </div>
                <div class="mb-2" v-else>
                    <p class="my-2">Your basket is empty.</p>
                    <a href="/basket" class="p-1 text-center btn btn-primary w-auto rounded small px-4 text-decoration-none">View basket</a>
                </div>
            </div>
        </div>
    </Transition>
    <div v-if="showBasketPopover" class="outside" v-on:click="showBasketPopover = false"></div>
</template>

<script>
    import dayjs from '@frontend/node_modules/dayjs';
    import advancedFormat from '@frontend/node_modules/dayjs/plugin/advancedFormat';

    export default {
        props: ['basket'],
        data() {
            return {
                showBasketPopover: false
            }
        },
        mounted() {
            this.emitter.on('toggleBasketPopover', data => {
                this.showBasketPopover = !this.showBasketPopover;
            });
        },
        computed: {
            basketTyres() {
                let vm = this;
                return this.basket?.products?.filter((product) => {
                    return product.product_type === 'product';
                });
            },
            basketServices() {
                let vm = this;
                return this.basket?.products?.filter((product) => {
                    return product.product_type == 'service' || product.product_type == 'cover';
                });
            },
            //This is to cover Batteries, and any other products which aren't Tyres/Services, Sorry.
            basketUpsells() {
                let vm = this;
                return this.basket?.products?.filter((product) => {
                    return product.product_type === 'battery';
                });
            },
            formattedDate() {
                if(this.basket?.app_date) {
                    dayjs.extend(advancedFormat);

                    return dayjs(this.basket.app_date).format('dddd Do MMMM YYYY');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';

    #basketPopover {
        z-index: 99999;
        min-width: 315px;
        right: 0;
        top: 50px;
        .arrow-up {
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-bottom: 7px solid $brand;
            top: -9px;
            @media screen and (min-width: 992px) and (max-width: 1199px) {
                right: 8px;
            }
            @media screen and (min-width: 1200px) and (max-width: 1399px) {
                right: 16px;
            }
            @media screen and (min-width: 1400px) {
                right: 25px;
            }
        }
    }

    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
    .outside {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index:99998;
        background-color: #000;
        opacity: 0.5;
      }
</style>